import { Reveal } from "./Reveal";

const TIMELINE = [
  {
    year: "1505",
    title: "El primer reloj portátil",
    text: "Peter Henlein, un cerrajero alemán de Núremberg, crea el “Huevo de Núremberg”, considerado el primer reloj de bolsillo de la historia.",
  },
  {
    year: "1675",
    title: "El muelle espiral",
    text: "Christiaan Huygens, físico neerlandés, perfecciona el muelle espiral. La precisión del reloj mecánico da un salto histórico desde Holanda.",
  },
  {
    year: "1810",
    title: "Nace el reloj de pulsera",
    text: "Abraham-Louis Breguet diseña el primer reloj de pulsera de la historia para Carolina Murat, reina de Nápoles.",
  },
  {
    year: "1969",
    title: "La era moderna",
    text: "Seiko presenta el Astron, el primer reloj de cuarzo. Comienza la era de la precisión electrónica y el reloj se vuelve universal.",
  },
];

export const WatchHistory = () => {
  return (
    <section
      id="historia"
      data-testid="watch-history-section"
      className="relative py-24 sm:py-36 px-6 sm:px-12 bg-[var(--brand-bg)] overflow-hidden"
    >
      {/* Subtle gold radial accent */}
      <div
        className="pointer-events-none absolute -top-32 -right-32 w-[520px] h-[520px] rounded-full opacity-[0.07] blur-3xl"
        style={{ background: "var(--brand-gold)" }}
      />

      <div className="max-w-7xl mx-auto">
        <Reveal>
          <div className="font-accent-rw text-[11px] uppercase tracking-[0.4em] text-[var(--brand-gold)] mb-6 flex items-center gap-3">
            <span className="w-8 h-px bg-[var(--brand-gold)]" />
            Historia
          </div>
          <h2 className="font-serif-rw text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight text-slate-50 max-w-3xl">
            Cinco siglos midiendo <br />
            <em className="italic text-[var(--brand-gold)] font-light">
              el tiempo del hombre.
            </em>
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {/* Video + intro */}
          <Reveal className="lg:col-span-7">
            <div
              className="relative aspect-video w-full overflow-hidden border border-white/10 group"
              data-testid="history-video-frame"
            >
              <video
                data-testid="history-video"
                src="https://videos.pexels.com/video-files/6867654/6867654-hd_1280_720_25fps.mp4"
                poster="https://images.pexels.com/videos/6867654/black-background-clock-shield-luxury-silver-6867654.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=720&w=1280"
                autoPlay
                muted
                loop
                playsInline
                preload="metadata"
                className="w-full h-full object-cover"
              />
              {/* Tint overlay for cinematic feel */}
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-tr from-[var(--brand-bg)]/60 via-transparent to-[var(--brand-gold)]/10" />
              <div className="pointer-events-none absolute bottom-0 left-0 right-0 p-5 sm:p-7 flex items-end justify-between">
                <p className="font-accent-rw text-[10px] uppercase tracking-[0.35em] text-slate-200/80">
                  El alma mecánica · 1505 → hoy
                </p>
                <span className="font-accent-rw text-[10px] tracking-[0.3em] text-[var(--brand-gold)]">
                  / Romero Watches
                </span>
              </div>
            </div>

            <p className="mt-10 text-base sm:text-lg text-slate-300 leading-relaxed font-light max-w-2xl">
              El reloj no nació como una joya, sino como un acto de rebeldía:
              el hombre quería llevar el tiempo en el bolsillo. Lo que comenzó
              en los talleres de Núremberg en el siglo XVI, perfeccionaron los
              físicos holandeses en el XVII y convirtieron en arte los maestros
              suizos en el XIX. Cada reloj que vendemos hereda esa misma
              obsesión: precisión, oficio y belleza.
            </p>
          </Reveal>

          {/* Timeline */}
          <div className="lg:col-span-5">
            <ol className="relative border-l border-white/10">
              {TIMELINE.map((item, i) => (
                <Reveal
                  key={item.year}
                  delay={i * 80}
                  className="relative pl-8 pb-12 last:pb-0"
                >
                  <li>
                    <span
                      className="absolute -left-[7px] top-1 w-3 h-3 rotate-45 border border-[var(--brand-gold)] bg-[var(--brand-bg)]"
                      aria-hidden
                    />
                    <div className="font-accent-rw text-[10px] uppercase tracking-[0.35em] text-[var(--brand-gold)]">
                      {item.year}
                    </div>
                    <h3 className="mt-2 font-serif-rw text-2xl sm:text-3xl font-light text-slate-50 leading-tight">
                      {item.title}
                    </h3>
                    <p className="mt-3 text-sm text-slate-400 leading-relaxed font-light max-w-md">
                      {item.text}
                    </p>
                  </li>
                </Reveal>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WatchHistory;
